
<template>
  <el-card v-if="wechat.status == 1" shadow="never" body-style="height:200px">
    <div class="mb"><span class="front-line">企业授权</span></div>
    <div class="flex align-items-center">
      <div class="hd">
        <el-image
          class="image indexr"
          :src="wechat.qrcode"
          :preview-src-list="[wechat.qrcode]"
        ></el-image>
      </div>
      <div class="bd flex column ml-sm">
        <div class="font-lg">{{ wechat.name }}</div>
        <div class="text-muted mt-xs">企业服务号</div>
          <div v-if="wechat.endtime == 0" class="mt-xs text-success flex align-items-center">微信认证 {{ wechat.endtime | parseTime('{y}/{m}/{d}') }} 获得 <span style="font-size:20px" class="ml-xs"><i class="iconfont icon-polygon-check"></i></span></div>
          <div v-else class="mt-xs flex align-items-center" :class="remind ? 'text-danger' : 'text-success'">微信认证 {{ wechat.endtime | parseTime('{y}/{m}/{d}') }} 到期 <span style="font-size:20px" class="ml-xs"><i class="iconfont" :class="remind ? 'icon-circle-warning' : 'icon-polygon-check'"></i></span></div>
          <div class="mt-xs text-success flex align-items-center">平台授权 {{ wechat.authtime | parseTime('{y}/{m}/{d}') }} 获得 <span style="font-size:20px" class="ml-xs"><i class="iconfont icon-polygon-check"></i></span></div>
      </div>
    </div>
  </el-card>

  <el-card v-else class="wechat-card img" shadow="never" body-style="height:220px">
    <div
      class="flex-center column"
      style="height: 220px;"
    >
      <div style="color: rgba(16, 16, 16, 1);">为您量身定制打造企业公众号、微信小程序</div>
      <el-button
        @click="apply"
        type="success"
        plain
        class="mb-md mt-lg"
      >立即授权</el-button>
      <span class="text-muted">还没有开通微信公众号？<el-button
          type="text"
          @click="toApply"
        >立即申请</el-button></span>
    </div>
  </el-card>
</template>

<script>
import { array2Object } from "@/utils/common";
export default {
  data() {
    return {
      wechatTypeArr: [
        { value: 1, title: "未认证订阅号" },
        { value: 2, title: "未认证服务号" },
        { value: 3, title: "已认证订阅号" },
        { value: 4, title: "已认证服务号" },
      ],
      now: parseInt(new Date().getTime() / 1000),
      remind: false
    };
  },

  computed: {
    god() {
      return this.$store.state.godStore;
    },

    wechat() {
      return Object.assign({}, this.$store.state.godStore.wechat);
    },

    wechatTypeObj() {
      return array2Object(this.wechatTypeArr, "value");
    },
  },

  created() {
    if( this.wechat.endtime - this.now < 30*24*3600 ) {
      this.remind = true
    }
  },

  beforeUpdate() {
    if( this.wechat.endtime - this.now < 30*24*3600 ) {
      this.remind = true
    }
  },

  methods: {
    toApply() {
      window.open("https://mp.weixin.qq.com/", "_blank");
    },

    apply() {
      if(this.wechat.status == 0) {
        // this.$router.push("/home/upgrade")
      }else if(this.wechat.status == 2 || this.wechat.status == 3) {
        const state = encodeURIComponent(window.location.href);
        const godid = this.$store.state.godStore.godid;
        window.location.href = `https://api.frippler.com/super/index.php?c=account&a=platform&do=qrpre&godid=${godid}&state=${state}`
      }
      
    },
  },
};
</script>

<style lang="scss">
.img {
  background: url('../../../assets/gongzhong.jpg') center center no-repeat; 
  background-size: auto 100%;
  height: 200px;
}
.el-card.wechat-card {
  .el-card__body {
    padding: 0;
  }
}
</style>

